<app-breadcrumbs></app-breadcrumbs>
<div class="store-number-toolbar">
  <div [cfaLoading]="isLoading">
    <button mat-raised-button (click)="loadDashboard()" color="primary" id="store-number-search-button"
      [disabled]=isStoreNumberInvalid()>
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput type="number" maxlength="5" minLength="5" (keydown.enter)="isStoreNumberInvalid() ? $event.preventDefault() : loadDashboard()"
        [(ngModel)]="storeNumberInput" autofocus [disabled]="isLoading" />
    </mat-form-field>
  </div>
  <app-health-nav [storeNumber]="formattedStoreNumber"></app-health-nav>
</div>

<div class="datadog-embed-wrapper">
  @if (iframeUrl) {
    <!-- Not lazy-loaded: the signed URL expires 30 minutes after it is minted, so
         the load should not be deferred behind a viewport check. -->
    <iframe class="datadog-embed" [src]="iframeUrl" title="Store Network [HNS Pilot]"
      referrerpolicy="no-referrer" allow="fullscreen"></iframe>
  } @else if (embedUnavailable) {
    <div class="datadog-embed-message">
      <mat-icon>error_outline</mat-icon>
      <p>The Datadog dashboard could not be loaded for store {{formattedStoreNumber}}.</p>
      <button mat-raised-button color="primary" (click)="loadDashboard()">Retry</button>
    </div>
  } @else if (!isLoading) {
    <div class="datadog-embed-message">
      <mat-icon>insights</mat-icon>
      <p>Enter a store number to view its Datadog dashboard.</p>
    </div>
  }
</div>
